import React, { Fragment, useState, useEffect, useContext } from 'react'
import AppContext from '../../contexts/AppContext'
import { Link } from 'react-router-dom'
import moment from "moment"
import Pagination from "react-js-pagination";
import Breadcrumbs from '../Breadcrumbs'
import Header from '../Header'
import Footer from '../Footer'
import { truncateString } from '../../services/posts'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencilAlt, faTag, faEye, faTrashRestore, faSearch, faSpinner, faCaretUp, faCaretDown, faSort, faShare, faShareSquare, faTimes, faComments } from '@fortawesome/free-solid-svg-icons'
import { faTrashAlt } from '@fortawesome/free-regular-svg-icons'

import { breadcrumbsBy } from '../../services/locations'
import { getStatusText, isPostExpired, canBeEdited, canBeRenewed, canBeReposted, canBeDeleted, canUndelete, canView, canBePublished, canPromote } from '../../services/posts'
import { searchProperty, searchFromHash, setEncoded, getEncoded, objToEncoded } from '../../services/search'
import { Helmet } from "react-helmet-async";
import { CheckBoxField, Modal } from '../UI'

const capitalize = s => { if (typeof s !== 'string') return ''; return s.charAt(0).toUpperCase() + s.slice(1) }

import useToastContext from "../../hooks/useToastContext";

const HeaderFilterPanel = ({ posts, categories, months, locations, search, changePage, loading, setSearchProperty, onSearch, searchActive }) => {

    const statuses = [
        {key: 'all', label: 'All Posts'},
        {key: 'active', label: 'Active'},
        {key: 'deleted', label: 'Deleted'},
        {key: 'draft', label: 'Draft'},
        {key: 'expired', label: 'Expired'},
        {key: 'unverified', label: 'Unverified'},
        {key: 'on-hold', label: 'On Hold, Changes required'},
    ]

    const status_label = statuses.filter(item => item.key == search.status || (!search.status && item.key == 'all'))[0].label
    var roots = []; categories.map(item => { if(roots.filter(rootItem => rootItem?.id == item.parent_id).length == 0) roots.push(item.category) })
    const category = search.category && (!(search.category + '').includes(',') ? categories.filter(item => search.category == item.id)[0] : roots.filter(item => (search.category + '').split(',').includes('' + item.id))[0]);
    const category_label = category ? category.name : 'Any Category'
    const month_label = months && search.month ? moment(months.filter(item => item == search.month)[0]).format('MMMM YYYY') : 'Any Month'
    const selectedLocation = locations && search.location_id ? locations.filter(item => item.id == search.location_id)[0] : null
    const location_label = selectedLocation ? (selectedLocation.name + (selectedLocation.location ? (', ' + selectedLocation.location.name) : '')) : 'Any Location'

    return (

        <div className="d-lg-flex d-block justify-content-between">
            <div className="d-lg-flex d-block">
                <h1>Posts</h1>

                <ul className="nav nav-pills ms-3">
                    <li className="nav-item dropdown">
                        <a className="nav-link dropdown-toggle" data-bs-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">{status_label}</a>
                        <div className="dropdown-menu">
                            {statuses.map(item =>
                                <a
                                    key={item.key} href=""
                                    className={'dropdown-item' + (item.key == search.status || (!search.status && item.key == 'all') ? ' active' : '')}
                                    onClick={e => {
                                        e.preventDefault()
                                        onSearch(setSearchProperty('status', item.key == 'all' ? null : item.key))
                                    }}
                                >{item.label}</a>
                            )}
                        </div>
                    </li>

                    <li className="nav-item dropdown">
                        <a className="nav-link dropdown-toggle" data-bs-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">{category_label}</a>
                        <div className="dropdown-menu">
                            <a
                                href=""
                                className={'dropdown-item' + (!search.category ? ' active' : '')}
                                onClick={e => {
                                    e.preventDefault()
                                    onSearch(setSearchProperty('category', null))
                                }}
                            >Any Category</a>
                            {roots.filter(item => !!item).map(rootItem =>
                                <Fragment key={rootItem.id}>
                                    <a
                                        href=""
                                        className={'font-weight-bold dropdown-item' + (search.category && (search.category + '').split(",").includes(rootItem.id + '') ? ' active' : '')}
                                        onClick={e => {
                                            e.preventDefault()
                                            onSearch(setSearchProperty('category', item.id))
                                        }}
                                    >{rootItem.name}</a>
                                    {categories.filter(item => item.parent_id == rootItem.id).map(item =>
                                        <a
                                            key={item.id} href=""
                                            className={'dropdown-item' + (item.id == search.category ? ' active' : '')}
                                            onClick={e => {
                                                e.preventDefault()
                                                onSearch(setSearchProperty('category', item.id))
                                            }}
                                        >&ndash; {item.name}</a>
                                    )}
                                </Fragment>
                            )}
                        </div>
                    </li>

                    <li className="nav-item dropdown">
                        <a className="nav-link dropdown-toggle" data-bs-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">{month_label}</a>
                        <div className="dropdown-menu">
                            <a
                                href=""
                                className={'dropdown-item' + (!search.month ? ' active' : '')}
                                onClick={e => {
                                    e.preventDefault()
                                    onSearch(setSearchProperty('month', null))
                                }}
                            >Any Month</a>
                            {months.map(item =>
                                <a
                                    key={item} href=""
                                    className={'dropdown-item' + (item == search.month ? ' active' : '')}
                                    onClick={e => {
                                        e.preventDefault()
                                        onSearch(setSearchProperty('month', item))
                                    }}
                                >{moment(item).format("MMMM YYYY")}</a>
                            )}
                        </div>
                    </li>

                    <li className="nav-item dropdown">
                        <a className="nav-link dropdown-toggle" data-bs-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">{location_label}</a>
                        <div className="dropdown-menu">
                            <a
                                href=""
                                className={'dropdown-item' + (!search.location_id ? ' active' : '')}
                                onClick={e => {
                                    e.preventDefault()
                                    onSearch(setSearchProperty('location_id', null))
                                }}
                            >Any Location</a>
                            {locations.map(item =>
                                <a
                                    key={item.id} href=""
                                    className={'dropdown-item' + (item.id == search.location_id ? ' active' : '')}
                                    onClick={e => {
                                        e.preventDefault()
                                        onSearch(setSearchProperty('location_id', item.id))
                                    }}
                                >{item.name + (item.location ? (', ' + item.location.name) : '')}</a>
                            )}
                        </div>
                    </li>

                    {search.post_id &&
                        <li className="nav-item dropdown">
                            <a
                                className="nav-link active" href="" role="button"
                                onClick={e => {
                                    e.preventDefault()
                                    onSearch(setSearchProperty('post_id', null))
                                }}
                            >
                                <span>{search.post_id}</span>
                                <FontAwesomeIcon className="ms-2" icon={faTimes} />
                            </a>
                        </li>
                    }


                </ul>

                <form className="form my-2 my-lg-0 mx-0 ms-lg-3" style={{flexGrow: 5}} onSubmit={e => {
                    e.preventDefault()
                    onSearch()
                }}>
                    <div className="d-flex">
                        <input
                            className="form-control me-1"
                            style={{height: 35}}
                            type="search"
                            onChange={e => {
                                setSearchProperty('query', e.target.value)
                            }}
                            value={search.query ? search.query : ''}
                            placeholder="Search"
                            aria-label="Search"
                        />
                        <div className="input-group-append">
                            <button className={"btn " + (searchActive ? 'btn-primary' : "btn-outline-primary")} type="submit" onClick={() => onSearch()} style={{height: 35}}>
                                {!loading && <FontAwesomeIcon icon={faSearch} />}
                                {loading && <FontAwesomeIcon icon={faSpinner} />}
                            </button>
                        </div>
                    </div>
                </form>

            </div>

            <div className="d-flex">
                {posts.data && posts.data.length > 0 && posts.last_page > 1 &&
                    <nav className="ms-lg-3">
                        <Pagination
                            activePage={search.page}
                            itemsCountPerPage={parseInt(posts.per_page)}
                            totalItemsCount={posts.total}
                            pageRangeDisplayed={5}
                            onChange={changePage}
                            itemClass="page-item"
                            linkClass="page-link"
                            prevPageText="Previous"
                            nextPageText="Next"
                            hideFirstLastPages={true}
                        />
                    </nav>
                }
            </div>
        </div>

    )
}

const PostTableHeader = ({ name, field, search, onSearch, setSearchProperty, inverseOrder }) => {
    const asc = inverseOrder ? 'desc' : 'asc'
    const desc = inverseOrder ? 'asc' : 'desc'
    return (
        <th
            className="cursor-pointer noselect text-nowrap"
            onClick={() => {
                const newDirection = (search.order && search.order.direction) ? (search.order.direction == asc ? desc : null) : asc
                onSearch(setSearchProperty('order', newDirection ? {
                    direction: newDirection,
                    by: field
                }: null))
            }}
        >
            <span className="text-uppercase text-muted" style={{letterSpacing: '-1px'}}>{name}</span>
            {(!search.order || (search.order.by != field)) &&
                <FontAwesomeIcon className="text-muted ms-2" icon={faSort} />
            }
            {search.order && search.order.by == field &&
                <span className="ms-2">
                    {search.order.direction == 'asc' && <FontAwesomeIcon icon={faCaretUp} />}
                    {search.order.direction == 'desc' && <FontAwesomeIcon icon={faCaretDown} />}
                </span>
            }
        </th>
    )
}

const PostsTable = ({ posts, search, setSearchProperty, onSearch, loadPosts, history }) => {

    const { data, postServices } = useContext(AppContext)

    const [ deleteLoading, setDeleteLoading ] = useState(null)
    const [ bulkLoading, setBulkLoading ] = useState(false)
    const [ undeleteLoading, setUndeleteLoading ] = useState(null)
    const [ repostLoading, setRepostLoading ] = useState(null)
    const [ renewLoading, setRenewLoading ] = useState(null)

    const [ selected, setSelected ] = useState({})
    const selectedCount = Object.entries(selected).filter(item => !!item[1]).length
    const selectedKeys = Object.entries(selected).filter(item => !!item[1]).map(item => item[0])
    const selectAllCheckbox = selectedCount > 0
    const allSelected = selectedCount == posts.data.length

    const draftsSelectedCount = posts.data.filter(item => selectedKeys.includes(item.post_id) && item.status == 0).length
    const canBeRepostedCount = posts.data.filter(item => selectedKeys.includes(item.post_id) && canBeReposted(item)).length
    const canBeRenewedCount = posts.data.filter(item => selectedKeys.includes(item.post_id) && canBeRenewed(item)).length
    const canBeDeletedCount = posts.data.filter(item => selectedKeys.includes(item.post_id) && canBeDeleted(item)).length

    const canBulkRepost = canBeRepostedCount == selectedCount && draftsSelectedCount == 0
    const canBulkRenew = canBeRenewedCount == selectedCount
    const canBulkDelete = canBeDeletedCount == selectedCount

    const [ showDialog, setShowDialog ] = useState(false)
    const [ dialogOptions, setDialogOptions ] = useState({})

    const addToast = useToastContext()

    const bulkRepost = () => {
        console.log('bulkRepost')
        setBulkLoading(true)
        postServices.bulkRepost(selectedKeys).then(res => {
            setShowDialog(false)
            loadPosts(false)
            setSelected({})
            setBulkLoading(false)
        }).catch(res => {
            if(res && res.data && res.data.message) addToast({title: 'Error', message: res.data.message, type: 'danger'})
            setBulkLoading(false)
            setShowDialog(false)
        })
    }

    const bulkRenew = () => {
        console.log('bulkRenew')
        setBulkLoading(true)
        postServices.bulkRenew(selectedKeys).then(res => {
            setShowDialog(false)
            loadPosts(false)
            setSelected({})
            setBulkLoading(false)
        }).catch(res => {
            if(res && res.data && res.data.message) addToast({title: 'Error', message: res.data.message, type: 'danger'})
            setBulkLoading(false)
            setShowDialog(false)
        })
    }

    const bulkDelete = () => {
        console.log('bulkDelete')
        setBulkLoading(true)
        postServices.bulkDelete(selectedKeys).then(res => {
            setShowDialog(false)
            loadPosts(false)
            setSelected({})
            setBulkLoading(false)
        }).catch(res => {
            if(res && res.data && res.data.message) addToast({title: 'Error', message: res.data.message, type: 'danger'})
            setBulkLoading(false)
            setShowDialog(false)
        })
    }

    const modalDialog = (options) => {
        return new Promise((resolve, reject) => {
            options.onButtonClick = button => {
                if(['cancel'].includes(button)){
                    setShowDialog(false)
                    reject()
                }
                if(['close', 'ok'].includes(button)){
                    setShowDialog(false)
                    reject()
                }
                if(['run'].includes(button)){
                    resolve()
                }
                if(['delete'].includes(button)){
                    setShowDialog(false)
                    resolve()
                }
            }
            options.show = showDialog
            setDialogOptions(options)
            setShowDialog(true)
        })
    }

    return (
        <div className="table-responsive mb-3">
            <Modal {...dialogOptions} show={showDialog} data={{run_disabled: bulkLoading}} />
            <table className="table table-sm table-bordered table-hover mb-0 bg-white">
                <thead className="thead-light">
                    <tr>
                        <PostTableHeader
                            name="Status"
                            field="status"
                            search={search}
                            onSearch={onSearch}
                            setSearchProperty={setSearchProperty}
                        />
                        <th className="text-center align-middle">
                            <CheckBoxField
                                checked={selectAllCheckbox}
                                className={allSelected ? '' : 'text-muted'}
                                onClick={() => {
                                    var newSelected = {}
                                    for(var i = 0; i < posts.data.length; i ++){
                                        newSelected[posts.data[i]['post_id']] = !allSelected
                                    }
                                    setSelected(newSelected)
                                }}
                            />
                        </th>
                        <th>
                            <span className="me-2 text-uppercase text-muted" style={{letterSpacing: '-1px'}}>Manage</span>
                            {selectedCount > 0 && !(canBulkRepost || canBulkRenew || canBulkDelete) &&
                                <button className="btn btn-sm btn-primary" disabled >No Actions Available</button>
                            }
                            {selectedCount > 0 && (canBulkRepost || canBulkRenew || canBulkDelete) &&
                                <span className="dropdown">
                                    <button className="btn btn-sm btn-primary dropdown-toggle" data-bs-toggle="dropdown" type="button" id="dropdownMenuButton" aria-haspopup="true" aria-expanded="false">Actions</button>
                                    <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">

                                        {canBulkRepost &&
                                            <a className="dropdown-item" href="" onClick={e => {
                                                e.preventDefault()
                                                modalDialog({
                                                    title: 'Repost ' + selectedCount + ' selected ads',
                                                    description: 'By re-posting multiple posts at one time you are confirming these posts are correct and ready to re-run at this time.',
                                                    buttons: ['close', 'run']
                                                }).then(bulkRepost).catch(res => {})
                                            }}>
                                                <FontAwesomeIcon icon={faShareSquare} className="text-secondary me-2" />
                                                <span>Repost {selectedCount} selected ads</span>
                                            </a>
                                        }

                                        {canBulkRenew && 
                                            <a className="dropdown-item" href="" onClick={e => {
                                                e.preventDefault()
                                                modalDialog({
                                                    title: 'Renew ' + selectedCount + ' selected ads',
                                                    description: 'Are you sure?',
                                                    buttons: ['close', 'run']
                                                }).then(bulkRenew).catch(res => {})
                                            }}>
                                                <FontAwesomeIcon icon={faShare} className="me-2 text-info" />
                                                <span>Renew {selectedCount} selected ads</span>
                                            </a>
                                        }

                                        {canBulkDelete &&
                                            <a className="dropdown-item" href="" onClick={e => {
                                                e.preventDefault()
                                                const canDelete = canBeDeletedCount == selectedCount
                                                modalDialog({
                                                    title: 'Delete ' + selectedCount + ' selected ads',
                                                    description: canDelete ? 'Are you sure? If you are deleting draft posts they cannot be undeleted.' : 'The list of selected post contains some ads that can\'t be deleted.',
                                                    buttons: canDelete ? ['close', 'run'] : ['ok'],
                                                    type: 'danger'
                                                }).then(bulkDelete).catch(res => {})
                                            }}>
                                                <FontAwesomeIcon icon={faShareSquare} className="me-2 text-danger" />
                                                <span>Delete {selectedCount} selected ads</span>
                                            </a>
                                        }

                                    </div>
                                </span>
                            }
                        </th>
                        <PostTableHeader
                            name="Title"
                            field="title"
                            search={search}
                            onSearch={onSearch}
                            setSearchProperty={setSearchProperty}
                        />
                        <PostTableHeader
                            name="Area"
                            field="location_id"
                            search={search}
                            onSearch={onSearch}
                            setSearchProperty={setSearchProperty}
                        />
                        <PostTableHeader
                            name="Category"
                            field="category"
                            search={search}
                            onSearch={onSearch}
                            setSearchProperty={setSearchProperty}
                        />
                        <PostTableHeader
                            name="Created at"
                            field="created_at"
                            search={search}
                            inverseOrder={true}
                            onSearch={onSearch}
                            setSearchProperty={setSearchProperty}
                        />
                        <PostTableHeader
                            name="Expires in"
                            field="expires_at"
                            search={search}
                            onSearch={onSearch}
                            setSearchProperty={setSearchProperty}
                        />
                        <th className="text-nowrap text-muted text-uppercase" style={{letterSpacing: '-1px'}}>ID</th>
                    </tr>
                </thead>
                <tbody>
                    {posts.data.map(post => {
                        const isExpired = isPostExpired(post)
                        return (
                            <tr
                                key={post.post_id}
                            >
                                <td
                                    className={
                                        (
                                            post.amount_to_pay > 0 ? 'table-danger' :
                                            [11].includes(post.status) ? 'table-warning' :
                                            [0].includes(post.status) ? 'table-danger' :
                                            [1].includes(post.status) ? 'table-success' :
                                            [4].includes(post.status) ? 'table-dark' :
                                            [2, 3].includes(post.status) ? 'table-info' :
                                            [5, 6, 7].includes(post.status) ? 'table-secondary' :
                                            ''
                                        ) + ' align-middle'
                                    }
                                >
                                    <small>
                                        {post.amount_to_pay > 0 ? 'Payment Required' : getStatusText(post.status)}
                                    </small>
                                </td>
                                <td className={"text-center align-middle" + (selected[post.post_id] ? ' table-active' : '')}>
                                    <CheckBoxField
                                        checked={selected[post.post_id]}
                                        onClick={() => {
                                            setSelected({...selected, [post.post_id]: !selected[post.post_id]})
                                        }}
                                    />
                                </td>
                                <td className={"text-nowrap align-middle" + (selected[post.post_id] ? ' table-active' : '')}>
                                    {canView(post) &&
                                        <a
                                            href={'/p/' + post.post_id}
                                            className="me-2"
                                            title="View Post"
                                        >
                                            <FontAwesomeIcon icon={faEye} className="d-inline d-xl-none" />
                                            <small className={"ms-1 d-none d-xl-inline"}>
                                                <span>view</span>
                                                {canBePublished(post) && <span>/publish</span>}
                                                {post.amount_to_pay > 0 && <span>/pay</span>}
                                            </small>
                                        </a>
                                    }
                                    {canBeEdited(post) &&
                                        <a
                                            href={'/create-post?post_id=' + post.post_id}
                                            className="me-2"
                                            title="Edit Post"
                                        >
                                            <FontAwesomeIcon icon={faPencilAlt} className="d-inline d-xl-none" />
                                            <small className="ms-1 d-none d-xl-inline">edit</small>
                                        </a>
                                    }

                                    {canUndelete(post) &&
                                        <a
                                            href=""
                                            className={'cursor-pointer me-2'}
                                            disabled={undeleteLoading == post.post_id}
                                            title="Undelete Post"
                                            onClick={e => {
                                                e.preventDefault()
                                                setUndeleteLoading(post.post_id)
                                                postServices.postUndelete(post.post_id).then(res => {
                                                    loadPosts(false)
                                                    setUndeleteLoading(null)
                                                    document.location.href = '/p/' + res.post_id
                                                }).catch(res => {
                                                    setUndeleteLoading(null)
                                                })
                                            }}
                                        >
                                            {undeleteLoading == post.post_id && <FontAwesomeIcon icon={faSpinner} spin />}
                                            {undeleteLoading != post.post_id && <FontAwesomeIcon icon={faTrashRestore} className="d-inline d-xl-none" />}
                                            <small className="ms-1 d-none d-xl-inline">undelete</small>
                                        </a>
                                    }

                                    {canBeRenewed(post) &&
                                        <a
                                            href=""
                                            className="me-2"
                                            disabled={renewLoading == post.post_id}
                                            title="Renew Post"
                                            onClick={e => {
                                                e.preventDefault()
                                                setRenewLoading(post.post_id)
                                                postServices.postRenew(post.post_id).then(res => {
                                                    loadPosts(false)
                                                    setRenewLoading(null)
                                                }).catch(res => {
                                                    setRenewLoading(null)
                                                })
                                            }}
                                        >
                                            {renewLoading == post.post_id && <FontAwesomeIcon icon={faSpinner} spin />}
                                            {renewLoading != post.post_id && <FontAwesomeIcon icon={faShare} className="d-inline d-xl-none" />}
                                            <small className="ms-1 d-none d-xl-inline">renew</small>
                                        </a>
                                    }

                                    {canBeDeleted(post) &&
                                        <span
                                            className={'cursor-pointer text-muted me-2'}
                                            disabled={deleteLoading == post.post_id}
                                            title="Delete"
                                            onClick={() => {
                                                if(![0, 5].includes(post.status)){
                                                    setDeleteLoading(post.post_id)
                                                    postServices.postDelete(post.post_id).then(res => {
                                                        loadPosts(false)
                                                        setDeleteLoading(null)
                                                        document.location.href = '/p/' + res.post_id
                                                    }).catch(res => {
                                                        if(res?.message) addToast({title: 'Error', message: res.message, type: 'danger'})
                                                        setDeleteLoading(null)
                                                    })
                                                }else{
                                                    modalDialog({
                                                        title: 'Are you sure want to delete this draft post?',
                                                        description: 'If you delete this post, it cannot be undeleted.',
                                                        buttons: ['cancel', 'delete'],
                                                        type: 'danger'
                                                    }).then(() => {
                                                        setDeleteLoading(post.post_id)
                                                        postServices.postDelete(post.post_id).then(res => {
                                                            loadPosts(false)
                                                            setDeleteLoading(null)
                                                        }).catch(res => {
                                                            setDeleteLoading(null)
                                                        })
                                                    }).catch(res => {})
                                                }
                                            }}
                                        >
                                            {deleteLoading == post.post_id && <FontAwesomeIcon icon={faSpinner} spin />}
                                            {deleteLoading != post.post_id && <FontAwesomeIcon icon={faTrashAlt} className="d-inline d-xl-none" />}
                                            {![0, 5].includes(post.status) && <small className="ms-1 d-none d-xl-inline">delete</small>}
                                            {[0, 5].includes(post.status) && <small className="ms-1 d-none d-xl-inline">delete draft</small>}
                                        </span>
                                    }

                                    {canBeReposted(post) &&
                                        <a
                                            className={'cursor-pointer me-2'}
                                            disabled={repostLoading == post.post_id}
                                            title="Repost"
                                            onClick={e => {
                                                e.preventDefault()
                                                setRepostLoading(post.post_id)
                                                postServices.postRepost(post.post_id).then(res => {
                                                    loadPosts(false).then(() => {
                                                        document.location.href = '/p/' + res.post_id
                                                    })
                                                    setRepostLoading(null)
                                                }).catch(res => {
                                                    addToast({title: 'Error', message: res.message, type: 'danger'})
                                                    setRepostLoading(null)
                                                })
                                            }}
                                        >
                                            {repostLoading == post.post_id && <FontAwesomeIcon icon={faSpinner} spin />}
                                            {repostLoading != post.post_id && <FontAwesomeIcon icon={faShareSquare} className="d-inline d-xl-none" />}
                                            <small className="ms-1 d-none d-xl-inline">repost</small>
                                        </a>
                                    }

                                    {canPromote(post) &&
                                       <a
                                            className="me-2"
                                            title="Promote post"
                                            href={"/promote-post/" + post.post_id}
                                        >
                                            <FontAwesomeIcon icon={faTag} className="d-inline d-xl-none" />
                                            <small className="ms-1 d-none d-xl-inline">promote</small>
                                        </a>
                                    }
                                </td>
                                <td className={"align-middle" + (selected[post.post_id] ? ' table-active' : '')}>
                                    <div className="d-flex flex-wrap justify-content-between">
                                        <div>
                                            <small className="me-2">
                                                {canView(post) ? (
                                                    <a href={'/p/' + post.post_id} className="text-decoration-none">{post.title}</a>
                                                ) : post.title}
                                            </small>
                                        </div>
                                        <div>
                                            {post.threads?.length > 0 &&
                                                <Link
                                                    tag="a"
                                                    className="badge bg-primary bg-opacity-25 text-body me-2"
                                                    to={'/account/messages#' + objToEncoded({
                                                        post_id: post.post_id
                                                    })}
                                                    title="Messages"
                                                >
                                                    <FontAwesomeIcon icon={faComments} className="me-1" />
                                                    {post.threads?.length}
                                                </Link>
                                            }
                                            { post.paid > 0 && <span
                                                className="badge bg-success bg-opacity-25 text-body me-2"
                                                title="Paid Post">
                                                Paid Post
                                            </span> }
                                            {post.promos.filter(item => item.status == 'active' && item.paid).map(item =>
                                                <a
                                                    href={item.choose_url}
                                                    key={item.id}
                                                    className={
                                                        'badge text-body text-decoration-none me-2 hover-opacity-50 ' + {
                                                            new: 'bg-primary',
                                                            active: 'bg-success bg-opacity-25',
                                                            expired: 'bg-warning',
                                                            canceled: 'bg-info'
                                                        }[item.status]
                                                    }
                                                >
                                                    {item.type_text}
                                                </a>
                                            )}
                                        </div>
                                    </div>
                                </td>
                                <td
                                    style={{ lineHeight: '1.15em' }}
                                    className={"align-middle" + (selected[post.post_id] ? ' table-active' : '')}
                                >
                                    <small>{post.location && post.location.name}</small>
                                </td>
                                <td
                                    style={{ lineHeight: '1.15em' }}
                                    className={"align-middle" + (selected[post.post_id] ? ' table-active' : '')}
                                >
                                    {post.categories && post.categories.map((item, key) =>
                                        <div
                                            key={item.id}
                                            className="text-truncate cursor-default" style={{maxWidth: '150px'}}
                                            title={[item.category?.name, item.name].filter(_item => !!_item).join(' - ')}
                                        >
                                            <small>{post.categories.length > 1 ? ((key + 1) + '.') : ''} {item.name}</small>
                                        </div>
                                    )}
                                </td>
                                <td
                                    style={{ lineHeight: '1.15em' }}
                                    className={"text-nowrap align-middle" + (selected[post.post_id] ? ' table-active' : '')}
                                >
                                    <small><b>{moment(post.created_at).format('MM/DD/YYYY hh:mm a')}</b></small>
                                    {post.reposted_id &&
                                        <small>
                                            <br />
                                            <span className="me-1">repost of</span>
                                            <a
                                                href=""
                                                title={post.reposted_id}
                                                onClick={e => {
                                                    e.preventDefault()
                                                    onSearch(setSearchProperty('post_id', search.post_id ? null : post.reposted_id))
                                                }}
                                            >{truncateString(post.reposted_id, 8)}</a>
                                        </small>
                                    }
                                    {post.renewed_at &&
                                        <small>
                                            <br />
                                            <span className="me-1">renewed at</span>
                                            <small>{moment(post.renewed_at).format('MM/DD/YYYY hh:mm a')}</small>
                                        </small>
                                    }
                                </td>
                                <td className={"text-nowrap align-middle" + (isExpired ? ' table-warning' : '')}>
                                    <small>{post.expires_at && moment(post.expires_at).fromNow(!isExpired)}</small>
                                </td>
                                <td className={"align-middle" + (selected[post.post_id] ? ' table-active' : '')}>
                                    <small>
                                        <a
                                            href=""
                                            title={post.post_id}
                                            onClick={e => {
                                                e.preventDefault()
                                                onSearch(setSearchProperty('post_id', search.post_id ? null : post.post_id))
                                            }}
                                        >{truncateString(post.post_id, 8)}</a>
                                    </small>
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    )
}

const Posts = ({ match, history }) => {

    const { data, postServices, location } = useContext(AppContext)
    const { user } = data.app
    const { userPosts } = postServices

    const [ loading, setLoading ] = useState(false)
    const [ posts, setPosts ] = useState({})
    const [ categories, setCategories ] = useState([])
    const [ months, setMonths ] = useState([])
    const [ locations, setLocations ] = useState([])

    const [ search, setSearch ] = useState({})
    const [ searchActive, setSearchActive ] = useState(false)

    const loadPosts = withFilterData => {
        return new Promise((resolve, reject) => {
            setLoading(true)
            setSearch(searchFromHash())
            userPosts(getEncoded(), withFilterData).then(res => {
                if(res.categories) setCategories(res.categories)
                if(res.months) setMonths(res.months)
                if(res.locations) setLocations(res.locations)
                setPosts(res.posts)
                setLoading(false)
                setSearchActive(false)
                resolve()
            }).catch(res => {
                if(res.status == 404) history.push("/page-not-found")
                if(res.status == 500) history.push("/server-error")
                reject()
            })
        })
    }

    useEffect(() => {
        loadPosts(true)
        const hashChangedHandle = () => loadPosts(false)
        window.addEventListener("hashchange", hashChangedHandle, false)
        return () => window.removeEventListener("hashchange", hashChangedHandle);
    }, [])

    const onSearch = newSearch => {
        setEncoded(newSearch ? newSearch : {... search})
    }

    const setSearchProperty = (type, value) => {
        const res = searchProperty(search, type, value)
        setSearch(res.search)
        if(!res.isEqual) setSearchActive(true)
        return res.search
    }

    const changePage = page => {
        setEncoded(setSearchProperty('page', page == 1 ? null : page))
    }

    return (
        <>
            <div>
                <Header history={history} fluid={true} />
                <main className="py-4">
                    <div className="container-fluid">
                        <Breadcrumbs list={breadcrumbsBy(location, [{url: '/account', title: 'Dashboard'}, {title: 'Posts'}])} />
                        <Helmet><title>{'Posts | ' + process.env.MIX_APP_NAME}</title></Helmet>

                        <HeaderFilterPanel
                            posts={posts}
                            categories={categories}
                            months={months}
                            locations={locations}
                            search={search}
                            loading={loading}
                            onSearch={onSearch}
                            changePage={changePage}
                            setSearchProperty={setSearchProperty}
                            searchActive={searchActive}
                        />

                        <div>
                            {posts.data && !posts.data.length && <p>No posts yet. <a href="/create-post">Create post</a>.</p>}
                            {posts.data && posts.data.length > 0 &&
                                <PostsTable
                                    history={history}
                                    posts={posts}
                                    search={search}
                                    onSearch={onSearch}
                                    loadPosts={loadPosts}
                                    setSearchProperty={setSearchProperty}
                                />
                            }
                            {posts.data && posts.data.length > 0 && posts.last_page > 1 &&
                                <nav>
                                    <Pagination
                                        activePage={search.page}
                                        itemsCountPerPage={parseInt(posts.per_page)}
                                        totalItemsCount={posts.total}
                                        pageRangeDisplayed={5}
                                        onChange={changePage}
                                        itemClass="page-item"
                                        linkClass="page-link"
                                        prevPageText="Previous"
                                        nextPageText="Next"
                                        hideFirstLastPages={true}
                                    />
                                </nav>
                            }
                        </div>
                    </div>
                </main>
            </div>
            <Footer />
        </>
    )
}

export default Posts
